var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0107 14.6012C17.4247 14.6012 17.7607 14.2652 17.7607 13.8512V11.9992C17.7607 11.5852 17.4247 11.2492 17.0107 11.2492H11.3187C10.9947 10.1822 10.0127 9.39821 8.84069 9.39821C7.40669 9.39821 6.23969 10.5652 6.23969 11.9992C6.23969 13.4342 7.40669 14.6012 8.84069 14.6012C10.0127 14.6012 10.9947 13.8172 11.3187 12.7492H13.4307V13.8512C13.4307 14.2652 13.7667 14.6012 14.1807 14.6012C14.5947 14.6012 14.9307 14.2652 14.9307 13.8512V12.7492H16.2607V13.8512C16.2607 14.2652 16.5967 14.6012 17.0107 14.6012ZM7.66569 1.99921H16.3347C19.7227 1.99921 21.9997 4.37721 21.9997 7.91621V16.0832C21.9997 19.6222 19.7227 21.9992 16.3337 21.9992H7.66569C4.27669 21.9992 1.99969 19.6222 1.99969 16.0832V7.91621C1.99969 4.37721 4.27669 1.99921 7.66569 1.99921ZM7.73879 12.0001C7.73879 11.3921 8.23379 10.8981 8.84079 10.8981C9.44779 10.8981 9.94279 11.3921 9.94279 12.0001C9.94279 12.6071 9.44779 13.1011 8.84079 13.1011C8.23379 13.1011 7.73879 12.6071 7.73879 12.0001Z",
    fill: "#200E32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.d0de3a6e.svg";
export { ForwardRef as ReactComponent };